import React from "react";
import { Tooltip, Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ThemeContext } from "../../theme/ThemeContext";
import { useContext } from "react";
import { AddBoxSharp } from "@mui/icons-material";
import { Box } from "@material-ui/core";


const ViewTransaction = () => {
  const [isShown, setIsShown] = React.useState(false);
  const { t } = useTranslation();
    const { darkMode, setDiaLogBoxBlur } = useContext(ThemeContext);
  
  return (
    <>
      <Tooltip title="Transaction History">
        <Box
          onMouseEnter={() => setIsShown(true)}
          onMouseLeave={() => setIsShown(false)}
          className={darkMode ? 'iconButton_dark' : 'iconButton'}
        >
          {isShown ? (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20"
              viewBox="0 0 16 20"
            >
              <path
                id="document"
                d="M9,10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Zm0,2a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM20,8.94a1.31,1.31,0,0,0-.06-.27V8.58a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,13.05,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Zm-3-3H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
                transform="translate(-4 -2)"
                fill={darkMode ? "#fff" : "#474a4e"}
                opacity="0.8" 
              />
            </svg>
          ) : (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="20"
              viewBox="0 0 16 20"
            >
              <path
                id="document"
                d="M9,10h1a1,1,0,0,0,0-2H9a1,1,0,0,0,0,2Zm0,2a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2ZM20,8.94a1.31,1.31,0,0,0-.06-.27V8.58a1.07,1.07,0,0,0-.19-.28h0l-6-6h0a1.07,1.07,0,0,0-.28-.19.32.32,0,0,0-.09,0A.88.88,0,0,0,13.05,2H7A3,3,0,0,0,4,5V19a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V8.94ZM14,5.41,16.59,8H15a1,1,0,0,1-1-1ZM18,19a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V5A1,1,0,0,1,7,4h5V7a3,3,0,0,0,3,3h3Zm-3-3H9a1,1,0,0,0,0,2h6a1,1,0,0,0,0-2Z"
                transform="translate(-4 -2)"
                fill={darkMode ? "#fff" : "#474a4e"}
                opacity="0.8" 
               />
            </svg>
          )}
        </Box>
      </Tooltip>
    </>
  );
};
export default ViewTransaction;
